import React from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { Title } from "./ui/Title";
import { Paragraph } from "./ui/Paragraph";
import { mediaQuery } from "react-styled-mediaquery";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ArrowLink } from "./ui/ArrowLink";
import { Link } from "react-scroll";
import { colors } from "../lib/constant";

const imgMore = require("../../assets/more.jpg");

const TitleStyle = styled(Title)`
  line-height: 48px;

  ${mediaQuery("<=", "tablet")`
    line-height: 34px;
  `}
`;

const ImgFoldiobox = styled(LazyLoadImage)`
  width: 100%;
  display: block;
`;

const DemoLink = styled(Link)`
  color: ${colors.primary};
`;

export const SectionFeaturesFoldiobox = () => {
  return (
    <>
      <Row between="xs" middle="xs" id="foldioboxContainer">
        <Col xs={false} md={5} lg={5}>
          <ImgFoldiobox
            src={imgMore}
            alt="Image foldiobox"
            effect="opacity"
            threshold={300}
          />
        </Col>

        <Col xs={12} md={6} lg={6}>
          <TitleStyle htmlLevel={2} theme="titleBodyStyle">
            Et plus encore ...
          </TitleStyle>
          <Paragraph className="foldioBox">
            Nous ne pouvons prédire les besoins et les attentes de demain. C’est
            pour cela que nous pensons que la seule solution possible est un
            accompagnement main dans la main entre les utilisateurs de la
            plateforme et nous. Dès lors, nous mettons en place un rendez-vous
            trimestriel/semestriel pour élaborer les prochaines évolutions de la
            plateforme.
          </Paragraph>
          <ArrowLink justifyContent="start" marginTop="25px">
            <DemoLink href="#" to="contact" smooth={true} duration={700}>
              Contactez-nous
            </DemoLink>
          </ArrowLink>
        </Col>
      </Row>
    </>
  );
};
